export default function getProductClip (configuatorType) {
  let clipHeight = 0
  switch (configuatorType){
    case 'patch-cord':
      clipHeight = 100
      break
    default:
      clipHeight = 114
      break
  }
  // eslint-disable-next-line
  // debugger

  let productSvg = document.getElementById('product')
  
  if (!productSvg) {
    return ''
  }
  
  let duplicateSvg = productSvg.cloneNode(true)

  let legend = document.getElementById('canvas-legend')
  if (legend) {
    legend.style.display = 'none'
  }

  
  let bBox = productSvg.getBBox()
  
  // Calculate viewBox with safety checks for edge cases (like MTP12)
  let viewBoxX = Math.max(0, bBox.width - 240)
  let viewBoxWidth = 260
  let viewBoxHeight = clipHeight
  
  duplicateSvg.setAttribute('viewBox', `${viewBoxX} 0 ${viewBoxWidth} ${ viewBoxHeight }`)

  // Find and update the clipping element in the CLONED SVG
  let clippingInClone = duplicateSvg.getElementsByClassName('clipping')[0]
  if (clippingInClone) {
    clippingInClone.setAttribute('clip-path', 'url(#snippet-b)')
  }
  
  // Also apply to original for real-time feedback in DOM
  let clipping = document.getElementsByClassName('clipping')[0]
  if (clipping) {
    clipping.style.clipPath = 'url(#snippet-b)'
  }
  
  let customLabels = document.getElementsByClassName('custom-label')
  Array.from(customLabels).forEach(el => {
    el.style.display= 'none'
  })

  let midIndicators = document.getElementsByClassName('mid-indicator')
  Array.from(midIndicators).forEach(el => {
    el.style.display= 'none'
  })

  let overlays = document.getElementsByClassName('overlay')
  Array.from(overlays).forEach(el => {
    el.style.display= 'none'
  })

  let serializedProduct = new XMLSerializer().serializeToString(duplicateSvg)
  serializedProduct = serializedProduct.replace(/<!---->/g, '')

  let base64Product = btoa(unescape(encodeURIComponent(serializedProduct)))

  
  // roll back hidden elements
  // Restore original clip-path in the cloned SVG (for completeness, though clone won't be reused)
  if (clippingInClone) {
    clippingInClone.setAttribute('clip-path', 'url(#everything)')
  }
  
  // Restore original clip-path in DOM
  if (clipping) {
    clipping.style.clipPath = 'none'
  }

  if (legend) {
    legend.style.display = 'block'
  }
  
  Array.from(customLabels).forEach(el => {
    el.style.display= 'block'
  })

  Array.from(midIndicators).forEach(el => {
    el.style.display= 'block'
  })

  Array.from(overlays).forEach(el => {
    el.style.display= 'block'
  })

  return `data:image/svg+xml;base64,${base64Product}`
}